import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { http_get } from '../utils/api_client';
import { API_ENDPOINTS } from '../utils/endpoints';
import Loader from '../../organisms/loader/Loader';
import DocEditor from './DocEditor';
import './DocEditor.scss';

// BL-117 — Docs editor entry. Mounted by the App router at
// /:companySlug/docs/:lmSlug/edit. Loads the Doc (draft content) and hands it
// to the editor. Store Provider comes from the router.
const EditPage = () => {
  const { companySlug, lmSlug } = useParams();
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    http_get(API_ENDPOINTS.GET_DOC(lmSlug))
      .then(({ data }) => { if (!cancelled) setDoc(data); })
      .catch(() => { if (!cancelled) setDoc(null); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [lmSlug]);

  if (loading) return <Loader />;
  if (!doc) return <div className="doc-missing">Doc not found.</div>;

  return (
    <DndProvider backend={HTML5Backend}>
      <DocEditor slug={lmSlug} companySlug={companySlug} initial={doc} />
    </DndProvider>
  );
};

export default EditPage;
